import { InsertionPosition } from "@redotech/redo-model/widget";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateTryFirstWidgetSettings = {
  name: "updateTryFirstWidgetSettings" as const,
  input: z.object({
    enabled: z.boolean(),
    clickOriginalAddToCartButton: z.boolean().optional(),
    customCss: z.string().optional(),
    button: z.object({
      text: z.string().nullish(),
      textColor: z.string().nullish(),
      bgColor: z.string().nullish(),
      borderColor: z.string().nullish(),
      subtext: z.string().nullish(),
      subtextColor: z.string().nullish(),
      subtextFontSize: z.string().nullish(),
    }),
    placement: z
      .object({
        button: z.object({
          selector: z.string(),
          placementType: createEnum(InsertionPosition),
        }),
      })
      .optional(),
  }),

  output: z.object({ success: z.boolean() }),
};
